import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Member',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Member',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Member',
    column_type: 'datetime',
  },
  company: {
    model_name: 'Member',
    column_type: 'string',
  },
  know_channel: {
    model_name: 'Member',
    column_type: 'string',
  },
  live_city: {
    model_name: 'Member',
    column_type: 'string',
  },
  name: {
    model_name: 'Member',
    column_type: 'string',
  },
  position: {
    model_name: 'Member',
    column_type: 'string',
  },
  gender: {
    model_name: 'Member',
    column_type: 'enum',
  },
  user: {
    model_name: 'Member',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  user_id: {
    model_name: 'Member',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'user',
      model_name: 'User',
      foreign_key: 'user_id',
    },
  },
  vaccination_record_image: {
    model_name: 'Member',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  business_experience: {
    model_name: 'Member',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, { filterColumnsExtend } = {}) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
